import React from 'react';
import { IntlProvider as IntlProviderBase } from 'react-intl';
import { deDE, enUS, Localization } from '@mui/material/locale';
import * as messages_de from '../../../locale/de.json';
import * as messages_en from '../../../locale/en.json';

const messages: Record<string, any> = {
  de: messages_de,
  en: messages_en,
};

const supportedLocales: Record<string, Localization> = {
  de: deDE,
  en: enUS,
};

export const IntlProvider: React.FC = ({ children }) => {
  const language = navigator.language.split('-').shift() ?? 'de';
  return (
    <IntlProviderBase locale={language} messages={messages[language]}>
      {children}
    </IntlProviderBase>
  );
};
